import React, { Fragment } from 'react'
import MoveView from 'components/MoveView'
import Corridor from 'assets/gltfs/Corridor'
import ControlWrapper from 'components/Controls/ControlWrapper'
import Hazard from 'components/Hazard/Hazard'
import HazardScore from 'components/Hazard/HazardScore'
import { SceneHazardItem } from 'types/Hazard'
import CanvasWrapper from '../CanvasWrapper'
import { useAppStore } from 'store/AppStore'
import { useGLTF } from '@react-three/drei'
import Rooms from 'data/rooms'
import { isIOS } from 'react-device-detect'

export default function KitchenHazardTest () {
  // Imagine this array coming from anywhere, such as a DB call
  const RoomHazards: SceneHazardItem[] = Rooms.hall.hazards as SceneHazardItem[]

  const roomVisible = useAppStore(state => state.roomVisible)
  RoomHazards.forEach((rh) => {
    if (rh.path.endsWith('gltf')) useGLTF.preload(rh.path)
  })
  const img = new Image()
  img.src = '/gltfs/Corridor/Hazards/Hospital_corridor.webp'

  return (
    <Fragment>
      <div className={'w-full h-body relative'}>
        <CanvasWrapper>
          <ControlWrapper>
            <Corridor />
          </ControlWrapper>

          {/* {roomVisible && RoomHazards.map((h, index) => { */}
          {/*  return (<Hazard key={index} hazard={h} />) */}
          {/* })} */}
          <Hazard hazard={RoomHazards[0]} />
          <Hazard hazard={RoomHazards[1]} />
          <Hazard hazard={RoomHazards[2]} />
          <Hazard hazard={RoomHazards[3]} />
          <Hazard hazard={RoomHazards[4]} />
          <Hazard hazard={RoomHazards[5]} />
          <Hazard hazard={RoomHazards[6]} />

          {/* Temporary solution until models can be redone */}
          {!isIOS && <Hazard hazard={RoomHazards[7]} />}
        </CanvasWrapper>

        {roomVisible &&
          <div>
            <HazardScore />
            <MoveView totalCount={4} />
          </div>
        }
      </div>

    </Fragment>
  )
}
